var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('Input', {
    staticStyle: {
      "width": "220px",
      "margin-right": "8px"
    },
    attrs: {
      "placeholder": "请输入联系人姓名",
      "clearable": "",
      "search": ""
    },
    on: {
      "on-change": _vm.searchCustomer
    },
    model: {
      value: _vm.searchtext,
      callback: function ($$v) {
        _vm.searchtext = $$v;
      },
      expression: "searchtext"
    }
  }), _c('Button', {
    attrs: {
      "type": "primary",
      "ghost": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.EditCustomerContactDrawer.openDrawer();
      }
    }
  }, [_vm._v("添加联系人")])], 1), _c('div', {
    staticClass: "page"
  }, [_c('span', [_vm._v("共" + _vm._s(_vm.totalRows) + "条")]), _c('Page', {
    staticStyle: {
      "margin-right": "24px"
    },
    attrs: {
      "total": _vm.totalRows,
      "page-size": 15,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadCustomerContact
    }
  })], 1), _c('div', {
    ref: "tableWrapper",
    staticClass: "customer-wrapper"
  }, _vm._l(_vm.customerContactList, function (item) {
    return _c('div', {
      key: item._id,
      class: {
        selected: _vm.isActive == item._id
      },
      on: {
        "click": function ($event) {
          return _vm.showCustomerDetail(item);
        }
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 0), _c('EditCustomerContactDrawer', {
    ref: "EditCustomerContactDrawer"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }